var map = {
	"./": 49915,
	"./ecosystem": 16459,
	"./ecosystem.tsx": 16459,
	"./graphql/associate.graphql": 37192,
	"./graphql/authorize.graphql": 74954,
	"./graphql/token.graphql": 62581,
	"./graphql/userInfo.graphql": 99720,
	"./graphql1/verify_user.graphql": 48511,
	"./index": 49915,
	"./index.tsx": 49915,
	"./wp": 62615,
	"./wp.tsx": 62615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20516;